// extracted by mini-css-extract-plugin
module.exports = {"recommendations-list__card":"styles_recommendations-list__card__1C4zt"};